import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    batchTypes: [],
    documentTypes: [],
    userDocTypes: [],
    batchType: {},
    docType: {}
};

const getters = {
    getBatchTypes: (state) => state.batchTypes,
    getDocumentTypes: (state) => state.documentTypes,
    getBatchType: (state) => state.batchType,
    getDocType: (state) => state.docType,
    getUserDocTypes: (state) => state.userDocTypes
};

const actions = {
    async getBatchTypesList(context, data) {
        await axios.get(`${backendUrl()}/getBatchTypesList`,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setBatchTypes', response.data)
        })
    },

    async getDocumentTypesList(context, data) {
        await axios.get(`${backendUrl()}/getDocumentTypesList`,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setDocumentTypes', response.data)
        })
    },

    async getUserDocTypesList(context, data) {
        await axios.get(`${backendUrl()}/getUserDocTypesList`,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setUserDocTypes', response.data)
        })
    },

    async deleteBatchTypes(context, data) {
        await axios.post(`${backendUrl()}/deleteBatchTypes`,
        {
            batchTypesName: data.batchSelected
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getBatchTypesList')
        })
    },

    async deleteDocumentTypes(context, data) {
        await axios.post(`${backendUrl()}/deleteDocumentTypes`,
        {
            documentTypesInternalName: data.documentSelected
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getDocumentTypesList')
        })
    },

    async deleteUserDocumentTypes(context, data) {
        await axios.post(`${backendUrl()}/deleteUserDocumentTypes`,
        {
            userDocumentTypesName: data.userDocumentSelected
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getDocumentTypesList')
        })
    },

    async addBatchType(context, data) {
        await axios.post(`${backendUrl()}/addBatchType`,
        {
            batchName: data.batchName,
            batchClass: data.batchClass
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getBatchTypesList')
        })
    },

    async addDocumentType(context, data) {
        await axios.post(`${backendUrl()}/addDocumentType`,
        {
            documentInternalName: data.internalName,
            documentName: data.name,
            userDocType: data.userDocType
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getDocumentTypesList')
        })
    },

    async addUserDocumentType(context, data) {
        await axios.post(`${backendUrl()}/addUserDocumentType`,
        {
            userDocName: data.userDocName,
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getDocumentTypesList')
        })
    },

    async editBatchtype(context, data)
    {
        await axios.post(`${backendUrl()}/editBatchtype`,
        {
            batchName: data.batchName,
            batchClass: data.batchClass,
            batchId: data.batchId
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getBatchTypesList')
        })
    },

    async editDocumentType(context, data)
    {
        await axios.post(`${backendUrl()}/editDocumentType`,
        {
            internalName: data.internalName,
            name: data.name,
            userDocType: data.userDocType,
            docTypeId: data.docTypeId
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getDocumentTypesList')
        })
    },

    async editUserDocumentType(context, data)
    {
        await axios.post(`${backendUrl()}/editUserDocumentType`,
        {
            name: data.userDocName,
            idUserDocType: data.userDocTypeId
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.dispatch('getUserDocTypesList')
        })
    },

    async getBatchTypeById(context, id) {
        await axios.get(`${backendUrl()}/getBatchType/` + id,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.commit('setBatchType', response.data)
        })
    },

    async getDocumentTypeById(context, id) {
        await axios.get(`${backendUrl()}/getDocType/` + id,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
            context.commit('setDocType', response.data)
        })
    }    
};

const mutations = {
    setBatchTypes:(state, batchTypes) => (state.batchTypes = batchTypes),
    setDocumentTypes:(state, documentTypes) => (state.documentTypes = documentTypes),
    setBatchType:(state, batchType) => (state.batchType = batchType),
    setDocType:(state, docType) => (state.docType = docType),
    setUserDocTypes:(state, userDocTypes) => (state.userDocTypes = userDocTypes)
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}